export function interpolateTemplate(template, variables) {
  if (!template) return template;
  return template.replace(/\{\{([\w.]+)\}\}/g, (match, key) => {
    const value = key.split('.').reduce((obj, k) => obj?.[k], variables);
    return value ?? match;
  });
}
